const toggleClass = 'accordion-active'

let uidCounter1 = 0
let uidCounter2 = 0

class Accordion {
  constructor (container) {
    this.uid = uidCounter1++
    this.container = container
    this.isToggling = false
    this.objects = []
    this.allowMultiple = typeof container.dataset.multiple !== 'undefined'
    if (!this.allowMultiple) {
      this.activeIndex = false // keeps track of active index when multiple are not allowed!
    }

    const items = container.querySelectorAll('.accordion-item')
    for (let i = 0, l = items.length; i < l; i++) {
      const obj = this.setupItem(items[i], i)
      this.objects.push(obj)
      if (!this.allowMultiple && obj.active) {
        if (this.activeIndex !== false) {
          // Already has an active item, and we don't allow multiple, so we close this one!
          obj.wrap.classList.remove(toggleClass)
          obj.active = false
        } else {
          this.activeIndex = i
        }
      }
    }
  }

  onToggle (obj, index) {
    if (this.isToggling) {
      return
    }
    this.isToggling = true
    const { wrap, content, inner } = obj
    content.style.maxHeight = inner.offsetHeight + 'px'
    window.requestAnimationFrame(() => {
      if (obj.active) { // is active, close it
        obj.active = false
        obj.toggle.ariaExpanded = 'false'
        obj.content.ariaExpanded = 'false'
        window.requestAnimationFrame(() => {
          wrap.classList.remove(toggleClass)
          this.isToggling = false
        })
      } else { // is not active, open it
        let closeObj = false
        if (!this.allowMultiple) {
          // If we do not allow multiple, close the previous one & store new index
          if (this.activeIndex !== false) {
            closeObj = this.objects[this.activeIndex]
            closeObj.content.style.maxHeight = closeObj.inner.offsetHeight + 'px'
            closeObj.active = false
            closeObj.toggle.ariaExpanded = 'false'
            closeObj.content.ariaExpanded = 'false'
          }
          this.activeIndex = index
        }
        obj.active = true
        obj.toggle.ariaExpanded = 'true'
        obj.content.ariaExpanded = 'true'
        window.requestAnimationFrame(() => {
          if (closeObj) { closeObj.wrap.classList.remove(toggleClass) }
          wrap.classList.add(toggleClass)
          this.isToggling = false
        })
      }
    })
  }

  setupItem (item, index) {
    const obj = {
      wrap: item,
      toggle: item.querySelector('.accordion-title'),
      content: item.querySelector('.accordion-content'),
      inner: item.querySelector('.accordion-text'),
      active: item.classList.contains(toggleClass)
    }

    // ARIA
    const uid = this.uid + '-' + uidCounter2++
    const contentId = 'accordion-panel-' + uid
    const toggleId = 'accordion-toggle-' + uid
    obj.toggle.id = toggleId
    obj.toggle.setAttribute('role', 'button')
    obj.toggle.setAttribute('aria-expanded', obj.active ? 'true' : 'false')
    obj.toggle.setAttribute('aria-controls', contentId)
    obj.content.id = contentId
    obj.content.setAttribute('aria-labelledby', toggleId)
    obj.content.setAttribute('aria-expanded', obj.active ? 'true' : 'false')

    // Keyboard accessibility
    obj.toggle.tabIndex = 0
    obj.toggle.addEventListener('keydown', (e) => {
      if (e.code === 'Enter' || e.code === 'Space') {
        e.preventDefault()
        this.onToggle(obj, index)
      }
    })

    obj.toggle.addEventListener('click', () => {
      this.onToggle(obj, index)
    })

    obj.content.addEventListener('transitionend', (event) => {
      if (!this.isToggling && obj.active && event.propertyName === 'max-height') {
        obj.content.style.removeProperty('max-height')
      }
    })

    return obj
  }
}

const instances = []
window.addEventListener('cmpb-layout-loaded', function (event) {
  var accordions = event.layout.querySelectorAll('.cmpb-block-accordion')
  for (let i = 0, l = accordions.length; i < l; i++) {
    instances.push(new Accordion(accordions[i]))
  }
})
